export default (slides) => slides.map((slide, i) => {
  const prevSlide = slides[i - 1];
  const nextSlide = slides[i + 1];
  return {
    ...slide,
    meta: {
      ...slide.meta,
      prev: (typeof slide.meta.prev === 'undefined') ? (prevSlide ? prevSlide.path : null) : slide.meta.prev, // eslint-disable-line
      next: (typeof slide.meta.next === 'undefined') ? (nextSlide ? nextSlide.path : null) : slide.meta.next, // eslint-disable-line
    },
  };
});
